export default __webpack_public_path__ + "media/images/annule-aeb44c91bb3f2781d763ae30da8648f6.png";